export default __webpack_public_path__ + "static/media/screen3.db3cda4a.png";